import api from './api';

export const startQrAuth = async () => {
  const { data } = await api.post('/vidaas/v2/auth/qr/start', {
    lifetime: 43200,
    scope: 'signature_session',
  });

  return data;
};

export const getVidaasStatus = async () => {
  const { data } = await api.get('/vidaas/v2/auth/status');
  return data;
};

export const exchangeAuthCode = async payload => {
  const { data } = await api.post('/vidaas/v2/auth/exchange', payload);
  return data;
};

export const signDocument = async payload => {
  const { data } = await api.post('/vidaas/v2/sign', payload);
  return data;
};

export const logoutVidaas = async () => {
  const { data } = await api.post('/vidaas/v2/auth/logout');
  return data;
};
